import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { resetToast } from '../../../store/toast/action';

const Toast = () => {
    const { toast } = useSelector(state => state) || {};
    const { open, message, autoHideDuration, type = 'error', vertical, horizontal } = toast || {};
    const dispatch = useDispatch();
    useEffect(() => {
        setTimeout(() => {
            if (open) {
                dispatch(resetToast());
            }
        }, autoHideDuration);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const handleClose = () => {
        dispatch(resetToast());
    };

    return (
        <Snackbar
            open={open}
            message={message}
            anchorOrigin={{ vertical, horizontal }}
            classes={{ anchorOriginBottomRight: 'mb-16' }}
            autoHideDuration={autoHideDuration}
        >
            <Alert onClose={handleClose} severity={type} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
    );
};

export default Toast;
